import IAddSendFriendRequest from "../../models/Form/IAddSendFriendRequest";

export const postSentFriendRequestState: IAddSendFriendRequest = {
    RequestEmailIds: [],
  };